$(window).load(function () {
    $(".herobanner").addClass("show");
});
$(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll >= 50) {
        $("#idenx-header").addClass("fixed");
    } else {
        $("#idenx-header").removeClass("fixed");
    }
});
window.addEventListener('scroll', handleScroll);
$(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll >= 50) {
        $("#headers").addClass("fixed");
    } else {
        $("#headers").removeClass("fixed");
    }
});
window.addEventListener('scroll', handleScroll);

function handleScroll() {
    var scrollPositions = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    if (document.documentElement.clientWidth >= 1900) {
        if (scrollPositions <= 40) {
            $('.herobanner .heorimage img').css('transform', 'scale(1)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.99999)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(0px)');
        };
        if (scrollPositions >= 41 && scrollPositions <= 100) {
            $('.herobanner .heorimage img').css('transform', 'scale(1.1222)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.98888)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(-35px)');
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        };
        if (scrollPositions >= 101 && scrollPositions <= 199) {
            $('.herobanner .heorimage img').css('transform', 'scale(1.1455)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.94888)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(-75px)');
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        }
        if (scrollPositions >= 201 && scrollPositions <= 299) {
            $('.herobanner .heorimage img').css('transform', 'scale(1.1699)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.91777)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(-90px)');
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        }
        if (scrollPositions >= 300 && scrollPositions <= 599) {


            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        }
        if (scrollPositions >= 600 && scrollPositions <= 700) {

            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '0');
        }
    }
    if (document.documentElement.clientWidth > 1700 && document.documentElement.clientWidth <= 1899) {
        if (scrollPositions <= 40) {
            $('.herobanner .heorimage img').css('transform', 'scale(1)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.99999)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(0px)');
        };
        if (scrollPositions >= 41 && scrollPositions <= 100) {
            $('.herobanner .heorimage img').css('transform', 'scale(1.1222)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.98888)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(-35px)');
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        };
        if (scrollPositions >= 101 && scrollPositions <= 199) {
            $('.herobanner .heorimage img').css('transform', 'scale(1.1455)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.94888)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(-75px)');
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        }
        if (scrollPositions >= 201 && scrollPositions <= 299) {
            $('.herobanner .heorimage img').css('transform', 'scale(1.1699)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.91777)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(-90px)');
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        }
        if (scrollPositions >= 300 && scrollPositions <= 599) {
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        }
        if (scrollPositions >= 600 && scrollPositions <= 700) {
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '0');
        }
    }
    if (document.documentElement.clientWidth > 1600 && document.documentElement.clientWidth <= 1699) {
        if (scrollPositions <= 40) {
            $('.herobanner .heorimage img').css('transform', 'scale(1)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.99999)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(0px)');
        };
        if (scrollPositions >= 41 && scrollPositions <= 100) {
            $('.herobanner .heorimage img').css('transform', 'scale(1.1222)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.98888)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(-35px)');
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        };
        if (scrollPositions >= 101 && scrollPositions <= 199) {
            $('.herobanner .heorimage img').css('transform', 'scale(1.1455)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.94888)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(-75px)');
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        }
        if (scrollPositions >= 201 && scrollPositions <= 299) {
            $('.herobanner .heorimage img').css('transform', 'scale(1.1699)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.91777)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(-90px)');
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        }
        if (scrollPositions >= 300 && scrollPositions <= 599) {
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        }
        if (scrollPositions >= 600 && scrollPositions <= 700) {
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '0');
        }
    }
    if (document.documentElement.clientWidth > 1500 && document.documentElement.clientWidth <= 1599) {
        if (scrollPositions <= 40) {
            $('.herobanner .heorimage img').css('transform', 'scale(1)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.99999)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(0px)');
        };
        if (scrollPositions >= 41 && scrollPositions <= 100) {
            $('.herobanner .heorimage img').css('transform', 'scale(1.1222)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.98888)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(-30px)');
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        };
        if (scrollPositions >= 101 && scrollPositions <= 199) {
            $('.herobanner .heorimage img').css('transform', 'scale(1.1455)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.94888)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(-65px)');
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        }
        if (scrollPositions >= 201 && scrollPositions <= 299) {
            $('.herobanner .heorimage img').css('transform', 'scale(1.1699)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.91777)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(-75px)');
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        }
        if (scrollPositions >= 300 && scrollPositions <= 599) {
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '0');
        }

    }
    if (document.documentElement.clientWidth > 1200 && document.documentElement.clientWidth <= 1499) {
        if (scrollPositions <= 40) {
            $('.herobanner .heorimage img').css('transform', 'scale(1)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.99999)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(0px)');
        };
        if (scrollPositions >= 41 && scrollPositions <= 100) {
            $('.herobanner .heorimage img').css('transform', 'scale(1.1222)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.98888)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(-25px)');
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        };
        if (scrollPositions >= 101 && scrollPositions <= 199) {
            $('.herobanner .heorimage img').css('transform', 'scale(1.1455)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.94888)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(-45px)');
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        }
        if (scrollPositions >= 201 && scrollPositions <= 299) {
            $('.herobanner .heorimage img').css('transform', 'scale(1.1699)');
            $('.herobanner .inner-rwo h1').css('transform', 'scale(0.91777)');
            $('.affiliate-hero.show .hero-image .listimage img').css('transform', 'translateY(-65px)');
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '1');
        }
        if (scrollPositions >= 300 && scrollPositions <= 599) {
            $('.affiliate-hero.show .hero-image .listimage img').css('opacity', '0');
        }

    }
};
if (document.documentElement.clientWidth > 1900) {
    var scrollPositions = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    if (document.documentElement.clientWidth > 1900) {
        if (scrollPositions >= 4543 && scrollPositions <= 5543) {
            $('div#responsive .imagebox img').caa('opacity', '1');
        }
    }
    if (document.documentElement.clientWidth > 1600 && document.documentElement.clientWidth <= 1899) {
        if (scrollPositions >= 4170 && scrollPositions <= 5543) {
            $('div#responsive .imagebox img').caa('opacity', '1');
        }
    }
    if (document.documentElement.clientWidth > 1350 && document.documentElement.clientWidth <= 1599) {
        if (scrollPositions >= 3500 && scrollPositions <= 5543) {
            $('div#responsive .imagebox img').caa('opacity', '1');
        }
    }
    if (document.documentElement.clientWidth > 1200 && document.documentElement.clientWidth <= 1499) {
        if (scrollPositions >= 3000 && scrollPositions <= 5543) {
            $('div#responsive .imagebox img').caa('opacity', '1');
        }
    }
}
//scroll heading
// $(document).ready(function () {
//     $(document).on('scroll', function () {
//         var scrollPos = $(this).scrollTop();
//         var leftPos;
//         if (document.documentElement.clientWidth > 1900) {
//             leftPos = (760 - 0.1 * scrollPos) + 'vw';
//         }
//         else if (document.documentElement.clientWidth >= 1600 && document.documentElement.clientWidth < 1899) {
//             leftPos = (700 - 0.1 * scrollPos) + 'vw';
//         } else if (document.documentElement.clientWidth >= 1500 && document.documentElement.clientWidth < 1599) {
//             leftPos = (600 - 0.1 * scrollPos) + 'vw';
//         } else if (document.documentElement.clientWidth >= 1400 && document.documentElement.clientWidth < 1499) {
//             leftPos = (560 - 0.1 * scrollPos) + 'vw';
//         } else if (document.documentElement.clientWidth >= 1300 && document.documentElement.clientWidth < 1399) {
//             leftPos = (530 - 0.1 * scrollPos) + 'vw';
//         } else if (document.documentElement.clientWidth >= 1200 && document.documentElement.clientWidth < 1299) {
//             leftPos = (540 - 0.1 * scrollPos) + 'vw';
//         } else {
//             leftPos = (655 - 0.1 * scrollPos) + 'vw';
//         }

//         // Check if the left position is greater than or equal to 5vw
//         if (parseFloat(leftPos) <= 10) {
//             leftPos = '10vw'; // Set left position to 5vw
//         }

//         $('#scroll-heading').css({
//             'left': leftPos
//         });
//     });
// });


// Exit the loop to prevent unnecessary checks

// $(document).ready(function () {
//     $(window).scroll(function () {
//         var scrollPos = $(window).scrollTop();
//         $(".template-page-vital-home .ultimate .innreight ").each(function () {
//             var sectionId = $(this).attr("id");
//             var sectionOffset = $(this).offset().top;
//             var sectionHeight = $(this).outerHeight();
//             if (scrollPos >= sectionOffset && scrollPos < (sectionOffset + sectionHeight)) {
//                 if (document.documentElement.clientWidth >= 1900) {
//                     if (scrollPos >= 8800 && scrollPos <= 9900) {
//                         $('.ultimate .innreight li#block-1').addClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                     }
//                     if (scrollPos >= 9900 && scrollPos <= 10800) {
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-2').addClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                     }
//                     if (scrollPos >= 10800 && scrollPos <= 11500) {
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                         $('.ultimate .innreight li#block-3').addClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                     }
//                     if (scrollPos >= 11500 && scrollPos <= 12200) {
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').addClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                     }
//                     if (scrollPos >= 12200 && scrollPos <= 13600) {
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').addClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                     }
//                 }
//                 if (document.documentElement.clientWidth >= 1700 && document.documentElement.clientWidth <= 1899) {
//                     if (scrollPos >= 7574 && scrollPos <= 8674) {
//                         $('.ultimate .innreight li#block-1').addClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                     }
//                     if (scrollPos >= 8674 && scrollPos <= 9574) {
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-2').addClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                     }
//                     if (scrollPos >= 9574 && scrollPos <= 10174) {
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                         $('.ultimate .innreight li#block-3').addClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                     }
//                     if (scrollPos >= 10174 && scrollPos <= 11074) {
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').addClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                     }
//                     if (scrollPos >= 11074 && scrollPos <= 13000) {
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').addClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                     }
//                 }
//                 if (document.documentElement.clientWidth >= 1600 && document.documentElement.clientWidth <= 1699) {
//                     if (scrollPos >= 8015 && scrollPos <= 9015) {
//                         $('.ultimate .innreight li#block-1').addClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                     }
//                     if (scrollPos >= 9015 && scrollPos <= 10015) {
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-2').addClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                     }
//                     if (scrollPos >= 10015 && scrollPos <= 10715) {
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                         $('.ultimate .innreight li#block-3').addClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                     }
//                     if (scrollPos >= 10715 && scrollPos <= 11515) {
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').addClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                     }
//                     if (scrollPos >= 11515 && scrollPos <= 12815) {
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').addClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                     }
//                 }
//                 if (document.documentElement.clientWidth >= 1500 && document.documentElement.clientWidth <= 1599) {
//                     console.log("1500px desktop");
//                     if (scrollPos >= 7099 && scrollPos <= 7699) {
//                         $('.ultimate .innreight li#block-1').addClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                     }
//                     if (scrollPos >= 7699 && scrollPos <= 8399) {
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-2').addClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                     }
//                     if (scrollPos >= 8399 && scrollPos <= 8899) {
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                         $('.ultimate .innreight li#block-3').addClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                     }
//                     if (scrollPos >= 8899 && scrollPos <= 9399) {
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').addClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                     }
//                     if (scrollPos >= 9399 && scrollPos <= 9700) {
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').addClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                     }
//                 }

//                 if (document.documentElement.clientWidth >= 1400 && document.documentElement.clientWidth <= 1499) {
//                     console.log("1400px desktop");
//                     if (scrollPos >= 6811 && scrollPos <= 7511) {
//                         $('.ultimate .innreight li#block-1').addClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                     }
//                     if (scrollPos >= 7511 && scrollPos <= 8011) {
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-2').addClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                     }
//                     if (scrollPos >= 8011 && scrollPos <= 8611) {
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                         $('.ultimate .innreight li#block-3').addClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                     }
//                     if (scrollPos >= 8611 && scrollPos <= 9211) {
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').addClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                     }
//                     if (scrollPos >= 9211 && scrollPos <= 9911) {
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').addClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                     }
//                 }
//                 if (document.documentElement.clientWidth >= 1300 && document.documentElement.clientWidth <= 1399) {
//                     console.log("1300px desktop");
//                     if (scrollPos >= 6153 && scrollPos <= 6853) {
//                         $('.ultimate .innreight li#block-1').addClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                     }
//                     if (scrollPos >= 6853 && scrollPos <= 7420) {
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-2').addClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                     }
//                     if (scrollPos >= 7420 && scrollPos <= 8020) {
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                         $('.ultimate .innreight li#block-3').addClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                     }
//                     if (scrollPos >= 8020 && scrollPos <= 8587) {
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').addClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                     }
//                     if (scrollPos >= 8587 && scrollPos <= 9300) {
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').addClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                     }
//                 }
//                 if (document.documentElement.clientWidth >= 1200 && document.documentElement.clientWidth <= 1299) {
//                     if (scrollPos >= 6153 && scrollPos <= 6853) {
//                         $('.ultimate .innreight li#block-1').addClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                     }
//                     if (scrollPos >= 6853 && scrollPos <= 7420) {
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-2').addClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                     }
//                     if (scrollPos >= 7420 && scrollPos <= 8020) {
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                         $('.ultimate .innreight li#block-3').addClass('show');
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                     }
//                     if (scrollPos >= 8020 && scrollPos <= 8587) {
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-4').addClass('show');
//                         $('.ultimate .innreight li#block-5').removeClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                     }
//                     if (scrollPos >= 8587 && scrollPos <= 9300) {
//                         $('.ultimate .innreight li#block-4').removeClass('show');
//                         $('.ultimate .innreight li#block-5').addClass('show');
//                         $('.ultimate .innreight li#block-1').removeClass('show');
//                         $('.ultimate .innreight li#block-3').removeClass('show');
//                         $('.ultimate .innreight li#block-2').removeClass('show');
//                     }
//                 }
//             }
//         });
//     });
// });



// $(document).ready(function () {
//     $(window).scroll(function () {
//         // Get the vertical scroll position of the window
//         var scrollPos = $(window).scrollTop();

//         $(".template-page-vital-home .discover ").each(function () {
//             var sectionId = $(this).attr("id");
//             // Get the position of the current section
//             var sectionOffset = $(this).offset().top;
//             var sectionHeight = $(this).outerHeight();
//             if (scrollPos >= sectionOffset && scrollPos < (sectionOffset + sectionHeight)) {
//                 //console.log(scrollPos);
//                 if (document.documentElement.clientWidth >= 1900) {
//                     if (scrollPos >= 13961 && scrollPos <= 14361) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').removeClass('active');
//                     }
//                     if (scrollPos >= 14361 && scrollPos <= 14661) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').removeClass('active');
//                     }
//                     if (scrollPos >= 14661 && scrollPos <= 16000) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').addClass('active');

//                     }
//                 }
//                 if (document.documentElement.clientWidth >= 1700 && document.documentElement.clientWidth <= 1899) {
//                     if (scrollPos >= 12374 && scrollPos <= 12974) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').removeClass('active');
//                     }
//                     if (scrollPos >= 12974 && scrollPos <= 13274) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').removeClass('active');
//                     }
//                     if (scrollPos >= 13274 && scrollPos <= 13909.0908203125) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').addClass('active');

//                     }

//                 }
//                 if (document.documentElement.clientWidth >= 1600 && document.documentElement.clientWidth <= 1699) {
//                     if (scrollPos >= 12588 && scrollPos <= 12888) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').removeClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').removeClass('active');
//                     }
//                     if (scrollPos >= 12888 && scrollPos <= 13188) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').removeClass('active');
//                     }
//                     if (scrollPos >= 13188 && scrollPos <= 14315) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').addClass('active');

//                     }

//                 }
//                 if (document.documentElement.clientWidth >= 1500 && document.documentElement.clientWidth <= 1599) {
//                     if (scrollPos >= 10499 && scrollPos <= 10704) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').removeClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').removeClass('active');
//                     }
//                     if (scrollPos >= 10704 && scrollPos <= 10936) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').removeClass('active');
//                     }
//                     if (scrollPos >= 10936 && scrollPos <= 11699) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').addClass('active');

//                     }

//                 }
//                 if (document.documentElement.clientWidth >= 1400 && document.documentElement.clientWidth <= 1499) {
//                     if (scrollPos >= 10211 && scrollPos <= 10511) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').removeClass('active');
//                     }
//                     if (scrollPos >= 10511 && scrollPos <= 10711) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').removeClass('active');
//                     }
//                     if (scrollPos >= 10711 && scrollPos <= 11311) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').addClass('active');

//                     }

//                 }
//                 if (document.documentElement.clientWidth >= 1300 && document.documentElement.clientWidth <= 1399) {
//                     if (scrollPos >= 9587 && scrollPos <= 9887) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').removeClass('active');
//                     }
//                     if (scrollPos >= 9887 && scrollPos <= 10087) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').removeClass('active');
//                     }
//                     if (scrollPos >= 10087 && scrollPos <= 10653) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').addClass('active');

//                     }

//                 }
//                 if (document.documentElement.clientWidth >= 1200 && document.documentElement.clientWidth <= 1299) {
//                     if (scrollPos >= 9587 && scrollPos <= 9887) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').removeClass('active');
//                     }
//                     if (scrollPos >= 9887 && scrollPos <= 10087) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').removeClass('active');
//                     }
//                     if (scrollPos >= 10087 && scrollPos <= 10653) {
//                         $('.discover .innerrow .inneright .list div#type-1').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-2').addClass('active');
//                         $('.discover .innerrow .inneright .list div#type-3').addClass('active');

//                     }

//                 }
//                 if (document.documentElement.clientWidth >= 1200 && document.documentElement.clientWidth <= 1349) {

//                 }
//             }
//         });
//     });
// });

$(document).ready(function () {
    var intervalTime = 2000; // Change this value to adjust the interval time in milliseconds
    var currentIndex = 0;
    var $listItems = $('div#the-vital-home .filed-image ul li');

    setInterval(function () {
        // Remove 'active' class from all list items
        $listItems.removeClass('active');

        // Add 'active' class to the current list item
        $listItems.eq(currentIndex).addClass('active');

        // Increment index for next iteration
        currentIndex = (currentIndex + 1) % $listItems.length;
    }, intervalTime);
});



$('.counter').each(function () {
    var $this = $(this),
        countTo = $this.attr('data-count');
    $({ countNum: $this.text() }).animate({
        countNum: countTo
    }, {
        duration: 3000,
        easing: 'linear',
        step: function () {
            $this.text(Math.floor(this.countNum));
        },
        complete: function () {
            $this.text(this.countNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        }
    });
});

$(document).ready(function () {
    /* When user clicks the Icon */
    // new WOW().init();
    $(".nav-toggle").click(function () {
        $(this).toggleClass("active");
        // $(".nav_main").toggleClass("open");
        $("body").toggleClass("nav_open");
    });
});


if ($(window).width() < 767) {
    $('.nav-toggle').click(function () {
        $(".primary-menu").slideToggle('.primary-menu');
    });

    $("ul.sidebar__menu.sidebar--primary ul li a").click(function () {
        $(".nav-toggle").removeClass("active");
        $("ul.sidebar__menu.sidebar--primary").removeClass("open");
        $("body").removeClass("nav_open");
        $("html").removeClass("scroll");
        $("ul.sidebar__menu.sidebar--primary").slideUp('.primary-menu');
    });
}

//mobile scroll animation homepage
// $(window).scroll(function () {
//     var windowHeight = $(window).height();
//     var scrollTop = $(this).scrollTop();

//     var imageContainer = $('.mobile-slider');

//     var sectionBeforeBottom = windowHeight / 2;
//     if (scrollTop >= sectionBeforeBottom) {
//         var translateX = 2300 - (scrollTop - sectionBeforeBottom);

//         if ($(window).width() >= 1900) {
//             var translateX = 2300 - (scrollTop - sectionBeforeBottom);
//         }
//         else if ($(window).width() >= 1600 && $(window).width() < 1900) {
//             var translateX = 2600 - (scrollTop - sectionBeforeBottom);
//         }
//         else if ($(window).width() >= 1500 && $(window).width() < 1600) {
//             var translateX = 2200 - (scrollTop - sectionBeforeBottom);
//         }
//         else if ($(window).width() >= 1400 && $(window).width() < 1500) {
//             var translateX = 2200 - (scrollTop - sectionBeforeBottom);
//         }
//         else if ($(window).width() >= 1300 && $(window).width() < 1400) {
//             var translateX = 2000 - (scrollTop - sectionBeforeBottom);
//         }
//         else if ($(window).width() >= 1200 && $(window).width() < 1300) {
//             var translateX = 2000 - (scrollTop - sectionBeforeBottom);
//         }
//         // Apply the new transform
//         imageContainer.css({
//             'transform': 'translateX(' + translateX + 'px) translateZ(0px)'
//         });
//     }
//     var selector = $('.mobile-srolling ul.mobile-slider li:last-child');
//     var windowWidth = $(window).width(); // 1903
//     var elementWidth = selector.outerWidth(); //320
//     var halfelementWidth = elementWidth / 2 // 160
//     var elementOffsetLeft = selector?.offset()?.left;//distance from the left side
//     var horizontalCenter = windowWidth / 2; // 951


//     var final = horizontalCenter - halfelementWidth;
//     if (final >= elementOffsetLeft) {
//         $('.mobile-srolling').addClass('add-last-image');
//     }
//     else {
//         $('.mobile-srolling').removeClass('add-last-image');
//     }

//     // Get the vertical scroll position of the window
//     var scrollPos = $(window).scrollTop();
//     // console.log(scrollPos);



//     //*************************************** */
//     // box animation inside mobile
//     var smallbox = $('.mobile-srolling .relative-box-first .small-banner-image');
//     if (document.documentElement.clientWidth >= 1900) {


//         /**********************************/
//         if (scrollPos >= 2700 && scrollPos < 2800) {
//             smallbox.css({
//                 'transform': 'scale(0.1)',
//                 'opacity': '0.1'
//             });
//         };
//         if (scrollPos >= 2800 && scrollPos < 2900) {
//             smallbox.css({
//                 'transform': 'scale(0.2)',
//                 'opacity': '0.2'
//             });
//         };
//         if (scrollPos >= 2900 && scrollPos < 3000) {
//             smallbox.css({
//                 'transform': 'scale(0.3)',
//                 'opacity': '0.3'
//             });
//         };
//         if (scrollPos >= 3000 && scrollPos < 3100) {
//             smallbox.css({
//                 'transform': 'scale(0.4)',
//                 'opacity': '0.4'
//             });
//         };
//         if (scrollPos >= 3100 && scrollPos < 3200) {
//             smallbox.css({
//                 'transform': 'scale(0.5)',
//                 'opacity': '0.5'
//             });
//         };
//         if (scrollPos >= 3200 && scrollPos < 3300) {
//             smallbox.css({
//                 'transform': 'scale(0.6)',
//                 'opacity': '0.6'
//             });
//         };
//         if (scrollPos >= 3300 && scrollPos < 3400) {
//             smallbox.css({
//                 'transform': 'scale(0.7)',
//                 'opacity': '0.7'
//             });
//         };
//         if (scrollPos >= 3400 && scrollPos < 3500) {
//             smallbox.css({
//                 'transform': 'scale(0.8)',
//                 'opacity': '0.8'
//             });
//         };
//         if (scrollPos >= 3500 && scrollPos < 3600) {
//             smallbox.css({
//                 'transform': 'scale(0.9)',
//                 'opacity': '0.9'
//             });
//         };
//         if (scrollPos >= 3600) {
//             smallbox.css({
//                 'transform': 'scale(1)',
//                 'opacity': '1'
//             });
//         };
//         /*****************/
//         if (scrollPos >= 3700) {
//             $('.mobile-srolling').addClass('sticky-image');
//         }
//         else {
//             $('.mobile-srolling').removeClass('sticky-image');
//         }
//     }
//     if (document.documentElement.clientWidth >= 1600 && document.documentElement.clientWidth < 1900) {


//         /**********************************/
//         if (scrollPos >= 2585 && scrollPos < 2685) {
//             smallbox.css({
//                 'transform': 'scale(0.1)',
//                 'opacity': '0.1'
//             });
//         };
//         if (scrollPos >= 2685 && scrollPos < 2785) {
//             smallbox.css({
//                 'transform': 'scale(0.2)',
//                 'opacity': '0.2'
//             });
//         };
//         if (scrollPos >= 2785 && scrollPos < 2885) {
//             smallbox.css({
//                 'transform': 'scale(0.3)',
//                 'opacity': '0.3'
//             });
//         };
//         if (scrollPos >= 2885 && scrollPos < 2985) {
//             smallbox.css({
//                 'transform': 'scale(0.4)',
//                 'opacity': '0.4'
//             });
//         };
//         if (scrollPos >= 2985 && scrollPos < 3085) {
//             smallbox.css({
//                 'transform': 'scale(0.5)',
//                 'opacity': '0.5'
//             });
//         };
//         if (scrollPos >= 3085 && scrollPos < 3185) {
//             smallbox.css({
//                 'transform': 'scale(0.6)',
//                 'opacity': '0.6'
//             });
//         };
//         if (scrollPos >= 3185 && scrollPos < 3285) {
//             smallbox.css({
//                 'transform': 'scale(0.7)',
//                 'opacity': '0.7'
//             });
//         };
//         if (scrollPos >= 3285 && scrollPos < 3385) {
//             smallbox.css({
//                 'transform': 'scale(0.8)',
//                 'opacity': '0.8'
//             });
//         };
//         if (scrollPos >= 3385 && scrollPos < 3485) {
//             smallbox.css({
//                 'transform': 'scale(0.9)',
//                 'opacity': '0.9'
//             });
//         };
//         if (scrollPos >= 3485) {
//             smallbox.css({
//                 'transform': 'scale(1)',
//                 'opacity': '1'
//             });
//         };

//         if (scrollPos >= 3500) {
//             $('.mobile-srolling').addClass('sticky-image');
//         }
//         else {
//             $('.mobile-srolling').removeClass('sticky-image');
//         }
//     }
//     if (document.documentElement.clientWidth >= 1500 && document.documentElement.clientWidth < 1600) {


//         /**********************************/
//         if (scrollPos >= 2328 && scrollPos < 2428) {
//             smallbox.css({
//                 'transform': 'scale(0.1)',
//                 'opacity': '0.1'
//             });
//         };
//         if (scrollPos >= 2428 && scrollPos < 2528) {
//             smallbox.css({
//                 'transform': 'scale(0.2)',
//                 'opacity': '0.2'
//             });
//         };
//         if (scrollPos >= 2528 && scrollPos < 2628) {
//             smallbox.css({
//                 'transform': 'scale(0.3)',
//                 'opacity': '0.3'
//             });
//         };
//         if (scrollPos >= 2628 && scrollPos < 2728) {
//             smallbox.css({
//                 'transform': 'scale(0.4)',
//                 'opacity': '0.4'
//             });
//         };
//         if (scrollPos >= 2728 && scrollPos < 2828) {
//             smallbox.css({
//                 'transform': 'scale(0.5)',
//                 'opacity': '0.5'
//             });
//         };
//         if (scrollPos >= 2828 && scrollPos < 2928) {
//             smallbox.css({
//                 'transform': 'scale(0.6)',
//                 'opacity': '0.6'
//             });
//         };
//         if (scrollPos >= 2928 && scrollPos < 3028) {
//             smallbox.css({
//                 'transform': 'scale(0.7)',
//                 'opacity': '0.7'
//             });
//         };
//         if (scrollPos >= 3028 && scrollPos < 3128) {
//             smallbox.css({
//                 'transform': 'scale(0.8)',
//                 'opacity': '0.8'
//             });
//         };
//         if (scrollPos >= 3128 && scrollPos < 3228) {
//             smallbox.css({
//                 'transform': 'scale(0.9)',
//                 'opacity': '0.9'
//             });
//         };
//         if (scrollPos >= 3228) {
//             smallbox.css({
//                 'transform': 'scale(1)',
//                 'opacity': '1'
//             });
//         };
//         if (scrollPos >= 3250) {
//             $('.mobile-srolling').addClass('sticky-image');
//         }
//         else {
//             $('.mobile-srolling').removeClass('sticky-image');
//         }
//     }
//     if (document.documentElement.clientWidth >= 1400 && document.documentElement.clientWidth < 1500) {

//         /**********************************/
//         if (scrollPos >= 2246 && scrollPos < 2346) {
//             smallbox.css({
//                 'transform': 'scale(0.1)',
//                 'opacity': '0.1'
//             });
//         };
//         if (scrollPos >= 2346 && scrollPos < 2446) {
//             smallbox.css({
//                 'transform': 'scale(0.2)',
//                 'opacity': '0.2'
//             });
//         };
//         if (scrollPos >= 2446 && scrollPos < 2546) {
//             smallbox.css({
//                 'transform': 'scale(0.3)',
//                 'opacity': '0.3'
//             });
//         };
//         if (scrollPos >= 2546 && scrollPos < 2646) {
//             smallbox.css({
//                 'transform': 'scale(0.4)',
//                 'opacity': '0.4'
//             });
//         };
//         if (scrollPos >= 2646 && scrollPos < 2746) {
//             smallbox.css({
//                 'transform': 'scale(0.5)',
//                 'opacity': '0.5'
//             });
//         };
//         if (scrollPos >= 2746 && scrollPos < 2846) {
//             smallbox.css({
//                 'transform': 'scale(0.6)',
//                 'opacity': '0.6'
//             });
//         };
//         if (scrollPos >= 2846 && scrollPos < 2946) {
//             smallbox.css({
//                 'transform': 'scale(0.7)',
//                 'opacity': '0.7'
//             });
//         };
//         if (scrollPos >= 2946 && scrollPos < 3046) {
//             smallbox.css({
//                 'transform': 'scale(0.8)',
//                 'opacity': '0.8'
//             });
//         };
//         if (scrollPos >= 3046 && scrollPos < 3146) {
//             smallbox.css({
//                 'transform': 'scale(0.9)',
//                 'opacity': '0.9'
//             });
//         };
//         if (scrollPos >= 3146) {
//             smallbox.css({
//                 'transform': 'scale(1)',
//                 'opacity': '1'
//             });
//         };
//         if (scrollPos >= 3148) {
//             $('.mobile-srolling').addClass('sticky-image');
//         }
//         else {
//             $('.mobile-srolling').removeClass('sticky-image');
//         }

//     }
//     if (document.documentElement.clientWidth >= 1300 && document.documentElement.clientWidth < 1400) {


//         /**********************************/
//         if (scrollPos >= 2000 && scrollPos < 2100) {
//             smallbox.css({
//                 'transform': 'scale(0.1)',
//                 'opacity': '0.1'
//             });
//         };
//         if (scrollPos >= 2100 && scrollPos < 2200) {
//             smallbox.css({
//                 'transform': 'scale(0.2)',
//                 'opacity': '0.2'
//             });
//         };
//         if (scrollPos >= 2200 && scrollPos < 2300) {
//             smallbox.css({
//                 'transform': 'scale(0.3)',
//                 'opacity': '0.3'
//             });
//         };
//         if (scrollPos >= 2300 && scrollPos < 2400) {
//             smallbox.css({
//                 'transform': 'scale(0.4)',
//                 'opacity': '0.4'
//             });
//         };
//         if (scrollPos >= 2400 && scrollPos < 2500) {
//             smallbox.css({
//                 'transform': 'scale(0.5)',
//                 'opacity': '0.5'
//             });
//         };
//         if (scrollPos >= 2500 && scrollPos < 2600) {
//             smallbox.css({
//                 'transform': 'scale(0.6)',
//                 'opacity': '0.6'
//             });
//         };
//         if (scrollPos >= 2600 && scrollPos < 2700) {
//             smallbox.css({
//                 'transform': 'scale(0.7)',
//                 'opacity': '0.7'
//             });
//         };
//         if (scrollPos >= 2700 && scrollPos < 2800) {
//             smallbox.css({
//                 'transform': 'scale(0.8)',
//                 'opacity': '0.8'
//             });
//         };
//         if (scrollPos >= 2800 && scrollPos < 2900) {
//             smallbox.css({
//                 'transform': 'scale(0.9)',
//                 'opacity': '0.9'
//             });
//         };
//         if (scrollPos >= 2900) {
//             smallbox.css({
//                 'transform': 'scale(1)',
//                 'opacity': '1'
//             });
//         };
//         if (scrollPos >= 2901) {
//             $('.mobile-srolling').addClass('sticky-image');
//         }
//         else {
//             $('.mobile-srolling').removeClass('sticky-image');
//         }
//     }
//     if (document.documentElement.clientWidth >= 1200 && document.documentElement.clientWidth < 1300) {


//         /**********************************/
//         if (scrollPos >= 1880 && scrollPos < 1980) {
//             smallbox.css({
//                 'transform': 'scale(0.2)',
//                 'opacity': '0.2'
//             });
//         };
//         if (scrollPos >= 1980 && scrollPos < 2080) {
//             smallbox.css({
//                 'transform': 'scale(0.3)',
//                 'opacity': '0.3'
//             });
//         };
//         if (scrollPos >= 2080 && scrollPos < 2180) {
//             smallbox.css({
//                 'transform': 'scale(0.4)',
//                 'opacity': '0.4'
//             });
//         };
//         if (scrollPos >= 2180 && scrollPos < 2280) {
//             smallbox.css({
//                 'transform': 'scale(0.5)',
//                 'opacity': '0.5'
//             });
//         };
//         if (scrollPos >= 2280 && scrollPos < 2380) {
//             smallbox.css({
//                 'transform': 'scale(0.6)',
//                 'opacity': '0.6'
//             });
//         };
//         if (scrollPos >= 2380 && scrollPos < 2480) {
//             smallbox.css({
//                 'transform': 'scale(0.7)',
//                 'opacity': '0.7'
//             });
//         };
//         if (scrollPos >= 2480 && scrollPos < 2580) {
//             smallbox.css({
//                 'transform': 'scale(0.8)',
//                 'opacity': '0.8'
//             });
//         };
//         if (scrollPos >= 2580 && scrollPos < 2680) {
//             smallbox.css({
//                 'transform': 'scale(0.9)',
//                 'opacity': '0.9'
//             });
//         };
//         if (scrollPos >= 2680) {
//             smallbox.css({
//                 'transform': 'scale(1)',
//                 'opacity': '1'
//             });
//         };
//         if (scrollPos >= 2690) {
//             $('.mobile-srolling').addClass('sticky-image');
//         }
//         else {
//             $('.mobile-srolling').removeClass('sticky-image');
//         }
//     }
// });

$('#play-video').on('click', function () {
    $('#modal-video video').trigger('play');

});
$('#close-video').on('click', function () {
    $('#modal-video video').get(0).pause();

});

/************************** New Js ******************** */

$(window).scroll(function () {
    var windowHeight = $(window).height();
    var scrollTop = $(this).scrollTop();
    var imageContainer = $('.mobile-slider');
    var smallbox = $('.mobile-srolling .relative-box-first .small-banner-image');
    var sectionOffsetTop = $('.mobile-srolling').offset().top;
    var scrollPosRelative = scrollTop - sectionOffsetTop;

    var newpos = scrollTop + windowHeight / 2 - sectionOffsetTop;
    var translateX = -newpos + 600;

    imageContainer.css({
        'transform': 'translateX(' + translateX + 'px) translateY(0) translateZ(0)'
    });

    var selector = $('.mobile-srolling ul.mobile-slider li:last-child');
    var windowWidth = $(window).width();
    var elementWidth = selector.outerWidth();
    var halfelementWidth = elementWidth / 2;
    var elementOffsetLeft = selector.offset().left;
    var horizontalCenter = windowWidth / 2;

    var final = horizontalCenter - halfelementWidth;
    if (final >= elementOffsetLeft) {
        $('.mobile-srolling').addClass('add-last-image');
    } else {
        $('.mobile-srolling').removeClass('add-last-image');
    }

    var breakpoints = [
        { min: 600, max: 700, scale: 0.1, opacity: 0.1 },
        { min: 700, max: 800, scale: 0.2, opacity: 0.2 },
        { min: 800, max: 900, scale: 0.3, opacity: 0.3 },
        { min: 900, max: 1000, scale: 0.4, opacity: 0.4 },
        { min: 1000, max: 1100, scale: 0.5, opacity: 0.5 },
        { min: 1100, max: 1200, scale: 0.6, opacity: 0.6 },
        { min: 1200, max: 1300, scale: 0.7, opacity: 0.7 },
        { min: 1300, max: 1400, scale: 0.8, opacity: 0.8 },
        { min: 1400, max: 1500, scale: 0.9, opacity: 0.9 },
        { min: 1500, max: Infinity, scale: 1, opacity: 1 }
    ];

    var currentBreakpoint = breakpoints.find(bp => scrollPosRelative >= bp.min && scrollPosRelative < bp.max);

    if (currentBreakpoint) {
        smallbox.css({
            'transform': 'scale(' + currentBreakpoint.scale + ')',
            'opacity': currentBreakpoint.opacity
        });
    }

    if (scrollPosRelative >= 1600) {
        $('.mobile-srolling').addClass('sticky-image');
    } else {
        $('.mobile-srolling').removeClass('sticky-image');
    }
});

/*scroll header*/
$(window).scroll(function () {
    $(document).ready(function () {
        var windowHeight = $(window).height();
        var scrollTop = $(this).scrollTop();
        var sectionOffsetTop = $('#responsive').offset().top;

        var newpos = scrollTop + windowHeight / 2 - sectionOffsetTop;
        var scrollForHeading = -newpos + 600;

        if (scrollForHeading < 120) {
            scrollForHeading = 120;
        }

        $('#scroll-heading').css({
            'transform': 'translateX(' + scrollForHeading + 'px)'
        });
    });
});


/* headphone animation*/

$(document).ready(function () {
    $(window).scroll(function () {
        var scrollPos = $(window).scrollTop();

        $(".template-page-vital-home .ultimate .innreight").each(function () {
            var sectionOffset = $(this).offset().top;
            var sectionHeight = $(this).outerHeight();
            var sectionScrollPos = scrollPos - sectionOffset;

            if (sectionScrollPos >= 0 && sectionScrollPos < sectionHeight) {
                if (document.documentElement.clientWidth >= 1900) {
                    var block1Start = 0, block1End = 550;
                    var block2Start = 550, block2End = 1350;
                    var block3Start = 1350, block3End = 2150;
                    var block4Start = 2150, block4End = 2850;
                    var block5Start = 2850, block5End = 4000;
                }
                else if (document.documentElement.clientWidth >= 1651 && document.documentElement.clientWidth <= 1899) {
                    block1Start = 0, block1End = 550;
                    block2Start = 550, block2End = 1500;
                    block3Start = 1500, block3End = 2000;
                    block4Start = 2000, block4End = 2900;
                    block5Start = 2900, block5End = 4000;
                }
                else if (document.documentElement.clientWidth >= 1500 && document.documentElement.clientWidth <= 1650) {
                    block1Start = 0, block1End = 300;
                    block2Start = 300, block2End = 1000;
                    block3Start = 1000, block3End = 1500;
                    block4Start = 1500, block4End = 2000;
                    block5Start = 2000, block5End = 4000;
                }
                else if (document.documentElement.clientWidth >= 1400 && document.documentElement.clientWidth <= 1499) {
                    block1Start = 0, block1End = 300;
                    block2Start = 300, block2End = 1000;
                    block3Start = 1000, block3End = 1500;
                    block4Start = 1500, block4End = 2000;
                    block5Start = 2000, block5End = 4000;
                }
                else if (document.documentElement.clientWidth >= 1300 && document.documentElement.clientWidth <= 1399) {
                    block1Start = 0, block1End = 300;
                    block2Start = 300, block2End = 900;
                    block3Start = 900, block3End = 1500;
                    block4Start = 1500, block4End = 2000;
                    block5Start = 2000, block5End = 4000;
                }
                else if (document.documentElement.clientWidth >= 1200 && document.documentElement.clientWidth <= 1299) {
                    block1Start = 0, block1End = 300;
                    block2Start = 300, block2End = 900;
                    block3Start = 900, block3End = 1400;
                    block4Start = 1400, block4End = 1800;
                    block5Start = 1800, block5End = 3000;
                }
                if (sectionScrollPos >= block1Start && sectionScrollPos <= block1End) {
                    $('.ultimate .innreight li#block-1').addClass('show');
                    $('.ultimate .innreight li#block-2, .ultimate .innreight li#block-3, .ultimate .innreight li#block-4, .ultimate .innreight li#block-5').removeClass('show');
                } else if (sectionScrollPos >= block2Start && sectionScrollPos <= block2End) {
                    $('.ultimate .innreight li#block-2').addClass('show');
                    $('.ultimate .innreight li#block-1, .ultimate .innreight li#block-3, .ultimate .innreight li#block-4, .ultimate .innreight li#block-5').removeClass('show');
                } else if (sectionScrollPos >= block3Start && sectionScrollPos <= block3End) {
                    $('.ultimate .innreight li#block-3').addClass('show');
                    $('.ultimate .innreight li#block-1, .ultimate .innreight li#block-2, .ultimate .innreight li#block-4, .ultimate .innreight li#block-5').removeClass('show');
                } else if (sectionScrollPos >= block4Start && sectionScrollPos <= block4End) {
                    $('.ultimate .innreight li#block-4').addClass('show');
                    $('.ultimate .innreight li#block-1, .ultimate .innreight li#block-2, .ultimate .innreight li#block-3, .ultimate .innreight li#block-5').removeClass('show');
                } else if (sectionScrollPos >= block5Start && sectionScrollPos <= block5End) {
                    $('.ultimate .innreight li#block-5').addClass('show');
                    $('.ultimate .innreight li#block-1, .ultimate .innreight li#block-2, .ultimate .innreight li#block-3, .ultimate .innreight li#block-4').removeClass('show');
                }
            }
            else {
                $('.ultimate .innreight li#block-1,.ultimate .innreight li#block-2, .ultimate .innreight li#block-3, .ultimate .innreight li#block-4, .ultimate .innreight li#block-5').removeClass('show');
            }
        });
    });
});



$(document).ready(function () {
    $(window).scroll(function () {
        var scrollPos = $(window).scrollTop();

        $(".template-page-vital-home .discover").each(function () {
            var sectionOffset = $(this).offset().top;
            var sectionHeight = $(this).outerHeight();
            var sectionScrollPos = scrollPos - sectionOffset;
            if (sectionScrollPos >= 0 && sectionScrollPos < sectionHeight) {
                if (document.documentElement.clientWidth >= 1900) {
                    var block1Start = 0, block1End = 550;
                    var block2Start = 550, block2End = 950;
                    var block3Start = 950, block3End = 1500;
                }
                else if (document.documentElement.clientWidth >= 1651 && document.documentElement.clientWidth <= 1899) {
                    var block1Start = 0, block1End = 500;
                    var block2Start = 500, block2End = 700;
                    var block3Start = 700, block3End = 1500;
                }
                else if (document.documentElement.clientWidth >= 1500 && document.documentElement.clientWidth <= 1650) {
                    var block1Start = 0, block1End = 300;
                    var block2Start = 300, block2End = 500;
                    var block3Start = 500, block3End = 1500;
                }
                if (document.documentElement.clientWidth >= 1400 && document.documentElement.clientWidth <= 1499) {
                    var block1Start = 0, block1End = 300;
                    var block2Start = 300, block2End = 500;
                    var block3Start = 500, block3End = 1500;
                }
                if (document.documentElement.clientWidth >= 1300 && document.documentElement.clientWidth <= 1399) {
                    var block1Start = 0, block1End = 300;
                    var block2Start = 300, block2End = 500;
                    var block3Start = 500, block3End = 1500;
                }
                if (document.documentElement.clientWidth >= 1200 && document.documentElement.clientWidth <= 1299) {
                    var block1Start = 0, block1End = 300;
                    var block2Start = 300, block2End = 500;
                    var block3Start = 500, block3End = 1500;
                }

                if (sectionScrollPos >= block1Start && sectionScrollPos <= block1End) {
                    $('.discover .innerrow .inneright .list div#type-1').addClass('active');
                    $('.discover .innerrow .inneright .list div#type-2').removeClass('active');
                    $('.discover .innerrow .inneright .list div#type-3').removeClass('active');

                } else if (sectionScrollPos >= block2Start && sectionScrollPos <= block2End) {
                    $('.discover .innerrow .inneright .list div#type-1').addClass('active');
                    $('.discover .innerrow .inneright .list div#type-2').addClass('active');
                    $('.discover .innerrow .inneright .list div#type-3').removeClass('active');

                } else if (sectionScrollPos >= block3Start && sectionScrollPos <= block3End) {
                    $('.discover .innerrow .inneright .list div#type-1').addClass('active');
                    $('.discover .innerrow .inneright .list div#type-2').addClass('active');
                    $('.discover .innerrow .inneright .list div#type-3').addClass('active');
                }
            }
            else {
                $('.discover .innerrow .inneright .list div#type-1').removeClass('active');
                $('.discover .innerrow .inneright .list div#type-2').removeClass('active');
                $('.discover .innerrow .inneright .list div#type-3').removeClass('active');
            }
        });
    });
});
